import {
  ApartmentOutlined,
  AppstoreOutlined,
  BarChartOutlined,
  BookOutlined,
  ContainerOutlined,
  DotChartOutlined,
  FileTextOutlined,
  FolderOpenOutlined,
  FundProjectionScreenOutlined,
  PlusCircleOutlined,
  ProfileOutlined,
  RocketOutlined,
  TeamOutlined,
  LinkOutlined
} from '@ant-design/icons';

const adTools = {
  id: 'group-ad-tools',
  title: '灵犀',
  type: 'group',
  children: [
    // {
    //   id: 'resource-manage',
    //   title: '资源管理',
    //   type: 'collapse',
    //   icon: ProjectOutlined,
    //   children: [
    //     {
    //       id: 'programs',
    //       title: '剧目列表',
    //       type: 'item',
    //       url: '/programs',
    //       icon: BookOutlined
    //     }
    //   ]
    // },
    {
      id: 'ad-public',
      title: '广告投放',
      type: 'collapse',
      icon: RocketOutlined,
      children: [
        {
          id: 'ad-launchpad',
          title: '创建广告',
          type: 'item',
          url: '/ad-public/launchpad',
          icon: PlusCircleOutlined
        },
        {
          id: 'materials',
          title: '素材管理',
          type: 'item',
          url: '/ad-public/material',
          icon: FolderOpenOutlined
        },
        {
          id: 'copywriting',
          title: '文案管理',
          type: 'item',
          url: '/ad-public/writing',
          icon: FileTextOutlined
        },
        {
          id: 'programs',
          title: '剧目列表',
          type: 'item',
          url: '/programs',
          icon: BookOutlined
        },
        {
          id: 'mini-link',
          title: '小程序链接',
          type: 'item',
          url: '/mini-link',
          icon: LinkOutlined
        }
      ]
    },
    {
      id: 'ad-insight',
      title: '广告数据',
      type: 'collapse',
      icon: BarChartOutlined,
      children: [
        {
          id: 'ad-manager',
          title: '广告管理',
          type: 'item',
          url: '/ad-insight/ads-manager',
          icon: BarChartOutlined
        },
        {
          id: 'material-top',
          title: '素材消耗TOP',
          type: 'item',
          url: '/ad-insight/material-top',
          icon: DotChartOutlined
        },
        {
          id: 'designer-recovery',
          title: '素材师消耗回收',
          type: 'item',
          url: '/ad-insight/designer-recovery',
          icon: DotChartOutlined
        },
        {
          id: 'playlet-recovery',
          title: '短剧回收统计',
          type: 'item',
          url: '/ad-insight/playlet-recovery',
          icon: FundProjectionScreenOutlined
        },
        {
          id: 'optimizer-recovery',
          title: '优化师回收统计',
          type: 'item',
          url: '/ad-insight/optimizer-recovery',
          icon: FundProjectionScreenOutlined
        },
        {
          id: 'application-stats',
          title: '应用数据',
          type: 'item',
          url: '/ad-insight/application-stats',
          icon: ProfileOutlined
        }
      ]
    },
    {
      id: 'ad-account',
      title: '资产管理',
      type: 'collapse',
      icon: ContainerOutlined,
      children: [
        {
          id: 'ad-accounts',
          title: '广告账户',
          type: 'item',
          url: '/ad-account/accounts',
          icon: ContainerOutlined
        },
        {
          id: 'app-groups',
          title: '应用分组',
          type: 'item',
          url: '/ad-account/application-group',
          icon: AppstoreOutlined
        }
      ]
    },
    {
      id: 'account',
      title: '系统管理',
      type: 'collapse',
      icon: TeamOutlined,
      children: [
        {
          id: 'organization',
          title: '组织结构',
          type: 'item',
          url: '/account/organization',
          icon: ApartmentOutlined
        }
      ]
    }
  ]
};

export default adTools;
